import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Dropdown, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap'
import FeatherIcon from 'feather-icons-react';
// import CusCard from '../components/CusCard'
import CusCard from '../containers/CusCardContainer'
import '../../node_modules/font-awesome/css/font-awesome.min.css'
import { Row } from 'react-bootstrap';
import CustomFooter from '../components/Footer';
import CustomHeader from '../components/Header'



class ManageVehicleHealth extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        console.warn('Manage Props:',this.props)

        return (


            <div>
                {/* <CustomHeader></CustomHeader> */}

                <Row>
                    <CusCard data1="Vehicle Maintenance " data2="Activities" icon="credit-card" link="./VehicleManagement" ></CusCard>
                    <CusCard data1="My" data2="Reminders" icon="grid" link="./MyReminderActivity"></CusCard>
                    <CusCard data1="Maintenance" data2="Log" icon="file-text" link="./MaintenanceLog"></CusCard>
                    <CusCard data1="Adhoc " data2="Maintenance" icon="file-text" link="./AdhocActivity"></CusCard>
                    
                </Row>


            </div>



        );
    }
}


export default ManageVehicleHealth;